<template>
  <a-modal
    title="点餐名单"
    :width="640"
    :visible="visible"
    cancelText=""
    @ok="handleSubmit"
    @cancel="handleCancel"
    :confirmLoading="confirmLoading"
    :okText="okText"
  >
    <a-spin :spinning="loading">
      <div ref="capture">
        <a-card :title="'早餐（'+[list.length > 0 ? list[0].length : 0]+'）'">
          <a-tag style="margin-bottom: 8px" v-for="(item, index) in list[0]" :key="index">{{ item }}</a-tag>
        </a-card>
        <a-card :title="'午餐（'+[list.length > 0 ? list[1].length : 0]+'）'" :style="{ marginTop: '16px' }">
          <a-tag style="margin-bottom: 8px" v-for="(item, index) in list[1]" :key="index">{{ item }}</a-tag>
        </a-card>
        <a-card :title="'晚餐（'+[list.length > 0 ? list[2].length : 0]+'）'" :style="{ marginTop: '16px' }">
          <a-tag style="margin-bottom: 8px" v-for="(item, index) in list[2]" :key="index">{{ item }}</a-tag>
        </a-card>
      </div>
    </a-spin>
  </a-modal>
</template>

<script>
import { getDishesUserList } from '@/api/manage'
import html2canvas from 'html2canvas'

export default {
  name: 'ShowUsers',
  data () {
    return {
      visible: false,
      loading: false,
      form: this.$form.createForm(this),
      list: [],
      record: {},
      okText: '生成并保存图片',
      confirmLoading: false
    }
  },
  mounted () {
  },
  methods: {
    show (record) {
      this.visible = true
      this.record = record
      this.handleList(record.id)
    },
    handleList (id) {
      this.loading = true
      getDishesUserList({
        dishesId: id
      }).then((res) => {
        this.$nextTick(() => {
          this.list = res.result
        })
      })
        .catch((err) => this.requestFailed(err))
        .finally(() => {
          this.loading = false
        })
    },
    requestFailed (err) {
      console.log(err)
      // this.$notification['error']({
      //   message: '错误',
      //   description: ((err.response || {}).data || {}).msg || '请求出现错误，请稍后再试',
      //   duration: 4
      // })
    },
    handleSubmit () {
      this.confirmLoading = true
      html2canvas(this.$refs.capture).then((canvas) => {
        const img = document.createElement('a')
        img.href = canvas.toDataURL('image/jpeg').replace('image/jpeg', 'image/octet-stream')
        img.download = this.record.date + '-画餐人员.jpg'
        img.click()
        this.confirmLoading = false
      })
    },
    handleCancel () {
      this.confirmLoading = false
      this.visible = false
    }
  }
}
</script>
